import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CallbacksTableComponent } from './components/callbacks-table/callbacks-table.component';
import { CapacitacionModule } from './capacitacion/capacitacion.module';
import { CdTimerModule } from 'angular-cd-timer';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table'  
import { NgbdDatepickerPopup } from './components/datepicker-popup/datepicker-popup.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { SalesTableComponent } from './components/sales-table/sales-table.component';
import { TimepickerComponent } from './components/timepicker/timepicker.component';

@NgModule({
  declarations: [
    AppComponent,
    CallbacksTableComponent,
    NgbdDatepickerPopup,
    SafeUrlPipe,
    SalesTableComponent,
    TimepickerComponent,
  ],
  exports: [
    CallbacksTableComponent,
    
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CapacitacionModule,
    CdTimerModule,
    FormsModule,
    MatPaginatorModule ,
    MatTableModule,
    NgbModule,
  ],
  providers: [
    // {provide: NgbCalendar, useClass: NgbCalendarHebrew},
    // {provide: NgbDatepickerI18n, useClass: NgbDatepickerI18nHebrew}
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
